export function TimeFilter() {
    return function(timeString) {
        if (timeString && typeof timeString === 'string') {
            var timeComponents = timeString.split(/\s|:/);
            if (timeComponents && timeComponents.length >= 2) {
                var amPm = 'AM';

                var hour = parseInt(timeComponents[0]);
                if (hour >= 12) {
                    amPm = 'PM';
                    hour -= 12;
                }

                if (hour === 0) {
                    hour = 12;
                }

                return hour + ':' + timeComponents[1] + amPm;
            }
        }
        return null;
    };
}
